import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    border-radius: 4px;

    background-color: var(--panel-head);
    color: var(--default-color-font);
    
    box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.2);
    height: fit-content;
`;

export default Container;
